import React from "react";

export type Props = {
  children?: React.ReactNode;
  show: boolean;
  onClose?: () => void;
};

const Modal: React.FC<Props> = ({ children, show, onClose }) => {
  return (
    <div
      className="res-backdrop"
      id="res-backdrop"
      data-open={show}
      onClick={(e) => {
        // @ts-ignore
        if (e.target.id === "res-backdrop") {
          onClose && onClose();
        }
      }}
    >
      <div className="res-modal">{children}</div>
    </div>
  );
};

export default Modal;
